<template>
    <form @submit.prevent="submit" class="lc-name-stage form">
        <section class="invitations">
            <div class="invitation" v-for="(invite, index) in form.invites" :key="invite.id" :class="{ 'form__group--error' : form.errors.has(`invites.${index}.email`)}">
                <input type="text"
                       name="user"
                       placeholder="john@example.com"
                       autocomplete="off"
                       class="form__input"
                       v-model="invite.email"
                       ref="input"
                       @keydown.enter.prevent.stop="addInvite"
                       autofocus
                />
                <a v-if="form.invites.length > 1" @click.prevent="remove(index)" href="#" class="invitation__icon icon-button" v-tooltip="`Remove`">
                    <icon type="close" color="danger" size="18" />
                </a>
                <p v-if="form.errors.has(`invites.${index}.email`)" class="form__help form__help--error">{{ form.errors.get(`invites.${index}.email`) }}</p>
            </div>
            <a v-if="canInviteMore" @click.prevent="addInvite" href="#" class="lc-add-another invitations__link">+ add another</a>
        </section>
        <button type="submit" @click.prevent="submit" :disabled="form.busy" class="button button--primary button--block">Next</button>
        <footer class="form__footer">
            <p class="form__help">
                <a :disabled="form.busy" @click.prevent="skip" href="#">Skip this step</a>, you can add team mates any time.
            </p>
        </footer>
    </form>
</template>

<script>
import uuid from 'uuid/v4'
import Form from '../../../helpers/Form'
import Icon from '../../Global/Icon'

export default {
    name: 'InviteStage',

    props: {
        form: {
            type: Form,
            required: true
        }
    },

    mounted () {
        this.addInvite()
    },

    methods: {
        addInvite () {
            if (this.canInviteMore) {
                this.form.invites.push({ id: uuid(), email: '' })
                this.$nextTick(() => {
                    this.$refs.input[this.$refs.input.length - 1].focus()
                })
            }
        },

        remove (index) {
            this.form.invites.splice(index, 1)
            this.form.errors.forget()
        },

        skip () {
            this.form.skip_invites = true

            this.submit()
        },

        submit () {
            this.form.post('/api/creating').then(() => {
                this.$router.push('/lets-go')
            })
        }
    },

    computed: {
        canInviteMore () {
            return this.form.invites.length < 10
        }
    },

    components: {
        Icon
    }
}
</script>
